'use strict';

const without = require('lodash.without');
const GlobalContextBaseView = require('./GlobalContextBaseView');

/**
 * @class ConnectedBaseView
 * @extends GlobalContextBaseView
 */
const ConnectedBaseView = GlobalContextBaseView.extend({
    props: {},
    defaultProps: {},
    stores: [],

    /**
     * @param {object}  options
     * @param {object} [options.defaultProps] - default prop values (if getPropsFromStores is not overridden)
     * @param {array}  [options.stores]       - array of store constructors
     * @param {BaseView} [parentView]
     */
    constructor: function(options, parentView) {
        options = options || {};

        // bind store change handler to view
        this._updatePropsAndRender = this._updatePropsAndRender.bind(this);

        this.defaultProps = options.defaultProps || this.defaultProps;
        this.stores = options.stores || this.stores;
        this.context = options.context;
        this._contextStores = [];

        if (!this.context) {
            throw new Error('No context was provided to ConnectedBaseView.');
        }

        // Add all the stores to the view (attaching a _updatePropsAndRender change handler)
        this.stores.forEach(store => this.addStore(store));

        GlobalContextBaseView.call(this, options, parentView);

        // Set initial props and call render
        this._updatePropsAndRender();
    },

    /**
     * Add a single store to the view and attach change listener
     * @param store
     * @throws {Error} Store was not registered
     */
    addStore(store) {
        const contextStore = this.context.getStore(store);
        if (this._contextStores.indexOf(contextStore) < 0) {
            this._contextStores.push(contextStore);
            contextStore.addChangeListener(this._updatePropsAndRender);
        }
    },

    /**
     * Removes a store from the view and removes its change listener
     * @param store
     * @throws {Error} Store was not registered
     */
    removeStore(store) {
        const contextStore = this.context.getStore(store);
        if (this._contextStores.indexOf(contextStore) > -1) {
            this._contextStores = without(this._contextStores, contextStore);
            contextStore.removeChangeListener(this._updatePropsAndRender);
        }
    },

    /**
     * Handler attached/removed from stores in view
     *  - attaches props to view
     *  - calls render
     * @private
     */
    _updatePropsAndRender() {
        const propsFromStores = this.getPropsFromStores.apply(this, this._contextStores);
        this.props = Object.assign({}, propsFromStores, this.defaultProps);
        this.render();
    },

    /**
     * Method called before render that should return an object to that will be set as the view's props
     *  (Should be overridden)
     * @returns {Object|null}
     */
    getPropsFromStores(/*store1, store2, store3...*/) {},
});

module.exports = ConnectedBaseView;



// WEBPACK FOOTER //
// ./assets/js/global/reactHelpers/ConnectedBaseView.es.js